<template>
  <div id="slide-7" class="slide">
    <div class="container slide-content">
      <div class="row">
        <div class="col-md-8 offset-md-2 col-sm-12">
          <h1 class="is-pink mb-4 text-center">Great, just click here to share:</h1>

          <div id="share-private">
            <button class="btn btn-facebook is-center-block" @click="shareFacebook('private')">Post on Facebook</button>

            <div class="tab-show">
              <button class="btn btn-whatsapp" @click="shareWhatsApp('private')">Share via WhatsApp</button>
              <button class="btn btn-messenger" @click="shareMessenger('private')">Share via Messenger</button>
            </div>

            <div class="facebook-wrap">
              <img class="facebook-image" :src="facebookPrivate.image" :alt="facebookPrivate.title">
              <div class="facebook-text-wrap">
                <p class="facebook-title" v-text="facebookPrivate.title"></p>
                <p class="facebook-description" v-html="facebookPrivate.description"></p>
              </div>
            </div>
          </div>

          <button class="btn btn-gray is-center-block" @click="changeSlide(8)">Skip</button>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['facebook', 'facebookPrivate', 'sameJourneys', 'stationFrom', 'stationTo'],
  data() {
    return {

    }
  },
  methods: {
    changeSlide(i) {
      this.$emit('changeSlide', i);
      this.$ga.event('FA - data journey', 'Slide 6', 'Passed');
    },

    shareFacebook(type) {
      let here = window.location.href.split('?')[0];
      let toShareUrl = type === 'default' ? encodeURIComponent(`${here}share.php/${this.sameJourneys}/${this.stationFrom.id}/${this.stationTo.id}`) : encodeURIComponent(`${here}share.php/${this.sameJourneys}`);
      let shareURL = 'https://www.facebook.com/sharer/sharer.php?u='+toShareUrl;
      window.open(shareURL, '_blank', 'toolbar=no,location=0,status=no,menubar=no,scrollbars=yes,resizable=yes,width=600,height=250,top=300,left=300');
      this.$ga.event('FA - data journey', 'Share', 'Facebook');
      this.saveShare('facebook');
      this.$emit('shared');
      this.changeSlide(8);
    },

    shareMessenger(type) {
      let utm = type === 'default' ? '?utm_source=gla_share_080317&utm_campaign=share_commute&utm_medium=fb_messenger' : '?utm_source=gla_share_080317_1&utm_campaign=share_commute_1&utm_medium=fb_messenger'
      let link = window.location.href.split('?')[0] + utm;
      let app_id = '1809192029375088';
      window.open('fb-messenger://share?link=' + encodeURIComponent(link) + '&app_id=' + encodeURIComponent(app_id));
      this.$ga.event('FA - data journey', 'Share', 'Facebook Messenger');
      this.saveShare('messenger');
      this.$emit('shared');
      this.changeSlide(8);
    },

    shareWhatsApp(type) {
      let utm = type === 'default' ? '?utm_source=gla_share_080317&utm_campaign=share_commute&utm_medium=whatsapp' : '?utm_source=gla_share_080317_1&utm_campaign=share_commute_1&utm_medium=whatsapp'
      let link = window.location.href.split('?')[0]  + utm;
      let journeys = this.sameJourneys < 10 ? 'fewer than 10' : this.sameJourneys
      let message = `I’ve just found out that ${journeys} Londoners do my Tube journey every day 🚇. What’s the figure for your journey? Find in two minutes here 👉 ${link}`;
      window.open('whatsapp://send?text='+ encodeURIComponent(message));
      this.$ga.event('FA - data journey', 'Share', 'WhatsApp');
      this.saveShare('whatsapp');
      this.$emit('shared');
      this.changeSlide(8);
    },

    saveShare(platform) {
      axios.post('shareCounter.php', `platform=${platform}`)
            .then(response =>  {
              //update count?
            })
            .catch(err => console.log(err));
    }
  }
}
</script>

<style lang="scss" scoped>
  .slide-content {
    margin-top: 60px;
  }

  .facebook-wrap {
    margin-top: 30px;
  }

  .facebook-text-wrap {
    border: 1px solid #979797;
    padding: 10px;
  }

  .facebook-image {
    width: 100%;
    height: auto;
  }

  .facebook-title {
    font-size: 18px;
    line-height: 22px;
    font-weight: bold;
    color: #000000;
    margin: 0 0 10px;
  }

  .facebook-description {
    font-size: 14px;
    line-height: 20px;
    color: #000000;
    margin: 0;
  }

  .btn-facebook {
    margin-top: 30px;
  }

  .tab-show {
    display: none;
  }

  .btn-gray {
    padding: 12px 0;
    width: 350px;
    margin-top: 30px;
  }

  @media screen and (max-width: 1200px) {
    .slide-content {
      margin-top: 40px;
    }

    .tab-show {
      display: block;
    }

    .btn {
      width: 80%;
      padding: 12px 0;
      margin: 30px auto 0;
      font-size: 24px;
      display: block;
    }
  }

  @media screen and (max-width: 767px) {
    .slide-content {
      margin-top: 0;
    }

    h2 {
      padding: 5px;
      margin-bottom: 10px!important;
    }

    .facebook-text-wrap {
      text-align: left;
    }

    .btn {
      width: 100%;
      padding: 12px 0;
      margin-top: 30px;
      font-size: 24px;
    }
  }
</style>





// WEBPACK FOOTER //
// src/components/Slide7.vue